import { AUDIO_QUALITY_CHECK_STATUS } from "@/constants/audioQuality";
import { SelectedFile } from "@/types/types";

export const isAudioQualityCheckPending = (
  selectedFile: SelectedFile
): boolean =>
  selectedFile.audioQualityCheckStatus === AUDIO_QUALITY_CHECK_STATUS.pending;
